var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _dec11, _dec12, _dec13, _dec14, _dec15, _dec16, _dec17, _dec18, _dec19, _dec20, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15, _descriptor16, _descriptor17, _descriptor18, _descriptor19, _descriptor20, _descriptor21, _descriptor22;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Model, { attr } from '@ember-data/model';
import { computed } from '@ember/object';
import { tracked } from '@glimmer/tracking';
export let ExportType = /*#__PURE__*/function (ExportType) {
  ExportType["TRANSACTIONS"] = "transactions";
  ExportType["ITEMS_DETAIL"] = "items_detail";
  ExportType["ITEMS_SUMMARY"] = "items_summary";
  ExportType["ORDERS"] = "orders";
  ExportType["ORDERS_LEGACY"] = "orders_legacy";
  ExportType["SUBSCRIPTIONS"] = "subscriptions";
  return ExportType;
}({});

/**
 * Source: https://github.com/squareup/neptr/blob/master/app/support/report_name.rb
 */
export let ReportName = /*#__PURE__*/function (ReportName) {
  ReportName["ATTRIBUTED_TEAM_SALES_ITEM_SUMMARY"] = "attributed_team_sales_item_summary";
  ReportName["CATEGORY"] = "category_sales_report";
  ReportName["CATEGORY_ROLLUP"] = "category_rollup_sales_report";
  ReportName["COMPS"] = "comps_report";
  ReportName["DISCOUNTS"] = "discounts_report";
  ReportName["EMPLOYEE_SALES"] = "employee_sales_report";
  ReportName["ITEM_SALES"] = "item_sales_report";
  ReportName["KEY_STATS"] = "key_stats_report";
  ReportName["LABOR_VS_SALES"] = "labor_vs_sales_report";
  ReportName["MOBILE_STAFF_SALES"] = "mobile_staff_sales_report";
  ReportName["MODIFIER_SALES"] = "modifier_sales_report";
  ReportName["PAYMENT_METHODS"] = "payment_methods_report";
  ReportName["SALES_SUMMARY"] = "sales_summary_report";
  ReportName["SERVICE_CHARGES"] = "service_charges_report";
  ReportName["TAX_SUMMARY"] = "tax_summary_report";
  ReportName["TEAM_SALES_ITEM_SUMMARY"] = "team_sales_item_summary";
  ReportName["VENDOR_SALES"] = "vendor_sales_report";
  ReportName["VOIDS"] = "voids_report";
  return ReportName;
}({});
export let OutputType = /*#__PURE__*/function (OutputType) {
  OutputType["CSV"] = "csv";
  return OutputType;
}({});
export let ExportStatus = /*#__PURE__*/function (ExportStatus) {
  ExportStatus["SCHEDULED"] = "scheduled";
  ExportStatus["IN_PROGRESS"] = "in_progress";
  ExportStatus["ERROR"] = "error";
  ExportStatus["RETRYABLE"] = "retryable";
  ExportStatus["COMPLETED"] = "completed";
  ExportStatus["CANCELED"] = "canceled";
  ExportStatus["FINALIZING"] = "finalizing";
  return ExportStatus;
}({});
let Export = (_dec = attr('string', {
  readOnly: true
}), _dec2 = attr('string', {
  readOnly: true
}), _dec3 = attr('string'), _dec4 = attr('string'), _dec5 = attr('boolean'), _dec6 = attr('date'), _dec7 = attr('date'), _dec8 = attr('string'), _dec9 = attr('string'), _dec10 = attr('date', {
  readOnly: true
}), _dec11 = attr('date', {
  readOnly: true
}), _dec12 = attr('date', {
  readOnly: true
}), _dec13 = attr('number', {
  readOnly: true
}), _dec14 = attr('number', {
  readOnly: true
}), _dec15 = attr('number', {
  readOnly: true
}), _dec16 = attr('boolean', {
  readOnly: true
}), _dec17 = attr('boolean', {
  readOnly: true
}), _dec18 = attr('boolean'), _dec19 = attr('number', {
  readOnly: true
}), _dec20 = computed('isValid', 'isError'), _class = class Export extends Model {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "status", _descriptor, this);
    _initializerDefineProperty(this, "exportLink", _descriptor2, this);
    _initializerDefineProperty(this, "exportType", _descriptor3, this);
    _initializerDefineProperty(this, "outputType", _descriptor4, this);
    _initializerDefineProperty(this, "singleExport", _descriptor5, this);
    _initializerDefineProperty(this, "beginTime", _descriptor6, this);
    _initializerDefineProperty(this, "endTime", _descriptor7, this);
    _initializerDefineProperty(this, "requestBody", _descriptor8, this);
    _initializerDefineProperty(this, "requestOptions", _descriptor9, this);
    _initializerDefineProperty(this, "locale", _descriptor10, this);
    _initializerDefineProperty(this, "timezone", _descriptor11, this);
    _initializerDefineProperty(this, "scheduledAt", _descriptor12, this);
    _initializerDefineProperty(this, "createdAt", _descriptor13, this);
    _initializerDefineProperty(this, "completedAt", _descriptor14, this);
    _initializerDefineProperty(this, "rowCount", _descriptor15, this);
    _initializerDefineProperty(this, "currentRow", _descriptor16, this);
    _initializerDefineProperty(this, "timeRemainingMs", _descriptor17, this);
    _initializerDefineProperty(this, "isStale", _descriptor18, this);
    _initializerDefineProperty(this, "isCreatedInSession", _descriptor19, this);
    _initializerDefineProperty(this, "emailExport", _descriptor20, this);
    _initializerDefineProperty(this, "toastId", _descriptor21, this);
    _initializerDefineProperty(this, "retryAdapterError", _descriptor22, this);
  }
  async retry() {
    if (this.status === ExportStatus.RETRYABLE) {
      const adapter = this.store.adapterFor('reports/export');
      const updatedExport = await adapter.retry(this);
      if (updatedExport && updatedExport.status) {
        this.set('status', updatedExport.status);
      }
    }
  }
  async cancel() {
    if (this.status === ExportStatus.SCHEDULED || this.status === ExportStatus.IN_PROGRESS) {
      const adapter = this.store.adapterFor('reports/export');
      const updatedExport = await adapter.cancel(this);
      if (updatedExport && updatedExport.status) {
        this.set('status', updatedExport.status);
      }
    }
  }
  markStale() {
    this.set('isStale', true);
    const adapter = this.store.adapterFor('reports/export');
    adapter.dismissToast(this);
  }
  get isPersisted() {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    return this.isValid && !this.isError;
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "status", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "exportLink", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "exportType", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "outputType", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "singleExport", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "beginTime", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "endTime", [_dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "requestBody", [attr], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "requestOptions", [attr], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "locale", [_dec8], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "timezone", [_dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "scheduledAt", [_dec10], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "createdAt", [_dec11], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor14 = _applyDecoratedDescriptor(_class.prototype, "completedAt", [_dec12], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor15 = _applyDecoratedDescriptor(_class.prototype, "rowCount", [_dec13], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor16 = _applyDecoratedDescriptor(_class.prototype, "currentRow", [_dec14], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor17 = _applyDecoratedDescriptor(_class.prototype, "timeRemainingMs", [_dec15], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor18 = _applyDecoratedDescriptor(_class.prototype, "isStale", [_dec16], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor19 = _applyDecoratedDescriptor(_class.prototype, "isCreatedInSession", [_dec17], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor20 = _applyDecoratedDescriptor(_class.prototype, "emailExport", [_dec18], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor21 = _applyDecoratedDescriptor(_class.prototype, "toastId", [_dec19], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor22 = _applyDecoratedDescriptor(_class.prototype, "retryAdapterError", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "isPersisted", [_dec20], Object.getOwnPropertyDescriptor(_class.prototype, "isPersisted"), _class.prototype), _class);
export { Export as default };